import { mediaUrl } from "@/lib/api";

const ROOMS = ["Shirts", "Signs", "Classifieds", "Classes"];

/**
 * What the buyer is actually buying, drawn as a browser window: their name in the header,
 * their rooms, their prices, their green button. Every price in it is a real one off the
 * house catalog — nothing here is invented.
 */
export default function StoreMock({ shots = [], name = "YOUR SHOP", color = "#2563EB" }) {
    const rows = (shots.length ? shots : ROOMS.map((r) => ({ name: r, price: "" }))).slice(0, 4);
    return (
        <div className="overflow-hidden rounded-2xl border border-zinc-200 bg-white shadow-[0_40px_80px_-50px_rgba(0,0,0,0.45)]"
            data-testid="store-mock">
            <div className="flex items-center gap-2 border-b border-zinc-200 bg-zinc-50 px-3 py-2.5">
                <span className="flex gap-1.5">
                    {["#f87171", "#fbbf24", "#34d399"].map((c) => (
                        <span key={c} className="h-2.5 w-2.5 rounded-full" style={{ background: c }} />
                    ))}
                </span>
                <span className="ml-2 flex-1 truncate rounded-md border border-zinc-200 bg-white px-2.5 py-1 font-mono text-[11px] text-zinc-500"
                    data-testid="store-mock-url">
                    yourshop.13thav.com
                </span>
            </div>

            <div className="flex items-center gap-2.5 bg-zinc-950 px-4 py-3">
                <span className="grid h-7 w-7 place-items-center rounded-md font-display text-[13px] font-black text-zinc-950"
                    style={{ background: color }}>Y</span>
                <span className="font-display text-[15px] font-extrabold tracking-tight text-white">{name}</span>
                <span className="ml-auto hidden gap-3 sm:flex">
                    {ROOMS.map((r) => (
                        <span key={r} className="text-[11px] font-medium uppercase tracking-[0.14em] text-zinc-400">{r}</span>
                    ))}
                </span>
            </div>

            <div className="grid gap-3 p-4 sm:grid-cols-[1.25fr_1fr]">
                <div className="rounded-xl border border-zinc-200 bg-zinc-50 p-4">
                    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">Live designer</p>
                    <p className="mt-2 font-display text-xl font-extrabold leading-tight tracking-tight text-zinc-950">
                        Design it online.<br />We print it.
                    </p>
                    <div className="mt-3 h-20 rounded-lg border border-dashed border-zinc-300 bg-white"
                        style={{ backgroundImage: `radial-gradient(${color}22 1px, transparent 1px)`, backgroundSize: "12px 12px" }} />
                    <span className="mt-3 inline-flex rounded-full px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-zinc-950"
                        style={{ background: color }}>Add to cart</span>
                </div>
                <div className="space-y-2">
                    {rows.map((r, i) => (
                        <div key={`${r.name}-${i}`} className="flex items-center gap-2.5 rounded-lg border border-zinc-200 bg-white px-2.5 py-2">
                            {r.image ? (
                                <img src={mediaUrl(r.image)} alt="" loading="lazy"
                                    className="h-8 w-8 shrink-0 rounded-md border border-zinc-200 object-cover" />
                            ) : (
                                <span className="h-8 w-8 shrink-0 rounded-md bg-zinc-100" />
                            )}
                            <span className="min-w-0 flex-1">
                                <span className="block truncate text-[12px] font-semibold text-zinc-900">{r.name}</span>
                                <span className="block font-mono text-[11px] text-zinc-500">{r.price || "your price"}</span>
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
